import React, { useEffect, useState } from "react";
import adminApi from "@/lib/adminApi";
import { Users, HeartPulse, CalendarClock, FileText, ShieldAlert, UserCheck, UserX, Smartphone } from "lucide-react";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

export default function AdminDashboard() {
  const [s, setS] = useState(null);
  const nav = useNavigate();

  useEffect(() => {
    adminApi.get("/admin/dashboard/summary").then((r) => setS(r.data)).catch(() => toast.error("Failed to load"));
  }, []);

  const cards = [
    { label: "Doctors", value: s?.doctors_total ?? "…", icon: Users, tint: "bg-[#E6F0EC] text-[#0A4C36]", href: "/back-office/users" },
    { label: "Pending approval", value: s?.doctors_pending ?? "…", icon: ShieldAlert, tint: "bg-[#FCE7D9] text-[#8A5A34]", href: "/back-office/users?status=pending" },
    { label: "Active doctors", value: s?.doctors_activated ?? "…", icon: UserCheck, tint: "bg-[#E6F0EC] text-[#0A4C36]" },
    { label: "Blocked doctors", value: s?.doctors_blocked ?? "…", icon: UserX, tint: "bg-[#F8E7DF] text-[#B14A2A]" },
    { label: "Patients", value: s?.patients_total ?? "…", icon: HeartPulse, tint: "bg-[#E6F0EC] text-[#0A4C36]", href: "/back-office/patients" },
    { label: "Patient app users", value: s?.patient_app_users ?? "…", icon: Smartphone, tint: "bg-[#F7F4EC] text-[#5C7568]" },
    { label: "Appointments today", value: s?.appointments_today ?? "…", icon: CalendarClock, tint: "bg-[#FCE7D9] text-[#8A5A34]" },
    { label: "Total consultations", value: s?.consultations_total ?? "…", icon: FileText, tint: "bg-[#E6F0EC] text-[#0A4C36]" },
  ];

  return (
    <div className="max-w-6xl">
      <div className="mb-6">
        <div className="text-[11px] uppercase tracking-widest text-[#8A9992]">Overview</div>
        <h1 className="text-3xl font-semibold text-[#1F2A24] mt-1" style={{ fontFamily: "Instrument Sans" }}>Platform at a glance</h1>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {cards.map((c) => (
          <button
            key={c.label}
            onClick={() => c.href && nav(c.href)}
            disabled={!c.href}
            data-testid={`admin-stat-${c.label.toLowerCase().replace(/\s+/g, '-')}`}
            className={`card-soft p-5 text-left transition-transform ${c.href ? "hover:-translate-y-0.5 cursor-pointer" : "cursor-default"}`}
          >
            <div className={`w-9 h-9 rounded-xl flex items-center justify-center mb-4 ${c.tint}`}>
              <c.icon size={16} />
            </div>
            <div className="text-3xl font-semibold text-[#1F2A24]" style={{ fontFamily: "Instrument Sans" }}>{c.value}</div>
            <div className="text-xs text-[#6C7B72] mt-1">{c.label}</div>
          </button>
        ))}
      </div>

      <div className="mt-10 card-soft p-6">
        <div className="text-[11px] uppercase tracking-widest text-[#8A9992]">Quick actions</div>
        <div className="mt-3 flex flex-wrap gap-3">
          <button onClick={() => nav("/back-office/users?status=pending")} className="btn-emerald" data-testid="quick-pending">
            Review pending doctors ({s?.doctors_pending ?? 0})
          </button>
          <button onClick={() => nav("/back-office/users")} className="btn-outline-emerald">All doctors</button>
          <button onClick={() => nav("/back-office/patients")} className="btn-outline-emerald">All patients</button>
        </div>
      </div>
    </div>
  );
}
